import { Clickable, Col, Divider, Icon, Row, Text } from 'components';
import { addDays, addHours, addMinutes, addMonths, addWeeks, addYears } from 'date-fns';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 16px;
  gap: 4px;
  width: 264px;
  height: 453px;

  position: absolute;
  right: -527px;
  top: 19px;

  background: #fff;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.1);
  border-radius: 24px;
  z-index: 3;

  @media (max-width: 1024px) {
    top: 30px;
    right: 10px;
  }
`;

const MuteOptions = ({ setVisible, updateChatSettings, chatSettings }) => {
  const { t } = useTranslation();

  return (
    <Col pos="absolute">
      <Wrapper>
        <Clickable onClick={() => setVisible(false)}>
          <Row start pad="12px 0" between marg="0 0 4px">
            <Row start center>
              <Col noFlex wid="24px" ht="24px" centerAll>
                <Icon type="arrowLeft" col={theme.GREY_60} dimensions={16} />
              </Col>

              <Row start wid="200px" marg="-1px 0 0 8px">
                <Text b1 med>
                  {t('common.back')}
                </Text>
              </Row>
            </Row>
          </Row>
        </Clickable>

        <Divider />

        <Clickable>
          <Row start pad="12px 0" center>
            <Col noFlex wid="24px" ht="24px" centerAll>
              <Icon type="musicOff" col={theme.GREY_60} dimensions={18} />
            </Col>

            <Row start wid="200px" marg="-2px 0 0 8px">
              <Text b1 med>
                {t('chat.disableSound')}
              </Text>
            </Row>
          </Row>
        </Clickable>

        <Text b2 col={theme.GREY_60}>
          {t('chat.muteNotificationsFor')}
        </Text>

        <Clickable onClick={() => updateChatSettings('mutedUntil', addMinutes(new Date(), 30))}>
          <Row start pad="12px 0" center>
            <Col noFlex wid="24px" ht="24px" centerAll></Col>

            <Row start wid="200px" marg="-2px 0 0 8px">
              <Text b1 med>
                {t('chat.thirtyMinutes')}
              </Text>
            </Row>
          </Row>
        </Clickable>

        <Clickable onClick={() => updateChatSettings('mutedUntil', addHours(new Date(), 1))}>
          <Row start pad="12px 0" center>
            <Col noFlex wid="24px" ht="24px" centerAll></Col>

            <Row start wid="200px" marg="-2px 0 0 8px">
              <Text b1 med>
                {t('chat.oneHour')}
              </Text>
            </Row>
          </Row>
        </Clickable>

        <Clickable onClick={() => updateChatSettings('mutedUntil', addDays(new Date(), 1))}>
          <Row start pad="12px 0" center>
            <Col noFlex wid="24px" ht="24px" centerAll></Col>

            <Row start wid="200px" marg="-2px 0 0 8px">
              <Text b1 med>
                {t('chat.oneDay')}
              </Text>
            </Row>
          </Row>
        </Clickable>

        <Clickable onClick={() => updateChatSettings('mutedUntil', addWeeks(new Date(), 1))}>
          <Row start pad="12px 0" center>
            <Col noFlex wid="24px" ht="24px" centerAll></Col>

            <Row start wid="200px" marg="-2px 0 0 8px">
              <Text b1 med>
                {t('chat.oneWeek')}
              </Text>
            </Row>
          </Row>
        </Clickable>

        <Clickable onClick={() => updateChatSettings('mutedUntil', addMonths(new Date(), 1))}>
          <Row start pad="12px 0" center>
            <Col noFlex wid="24px" ht="24px" centerAll></Col>

            <Row start wid="200px" marg="-2px 0 0 8px">
              <Text b1 med>
                {t('chat.oneMonth')}
              </Text>
            </Row>
          </Row>
        </Clickable>

        <Divider />

        <Clickable onClick={() => updateChatSettings('mutedUntil', addYears(new Date(), 50))}>
          <Row start pad="12px 0" center>
            <Col noFlex wid="24px" ht="24px" centerAll>
              <Icon type="mute" col={theme.GREY_60} dimensions={20} />
            </Col>

            <Row start wid="200px" marg="-2px 0 0 8px">
              <Text b1 med>
                {t('chat.muteForever')}
              </Text>
            </Row>
          </Row>
        </Clickable>
      </Wrapper>
    </Col>
  );
};

export default MuteOptions;
